import React from "react";
import { useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import { ProtectedRoute } from "@ofqual/portal-components/components/ProtectedRoute";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { NewItem } from "./create/NewItem";
import { Item } from "./item/Item";
import { Items } from "./list/Items";
import { authSelector } from "../redux/selectors";
import { NewsRoles } from "../domain/userRole";

export const Component: React.FC = () => {
  const { path } = useRouteMatch();
  const { isInRole } = useAuth(authSelector);
  const isNewsAdmin = () => isInRole(...NewsRoles);

  return (
    <Switch>
      <ProtectedRoute path={path} check={isNewsAdmin} exact>
        <Items />
      </ProtectedRoute>

      <ProtectedRoute path={`${path}/new`} check={isNewsAdmin} exact>
        <NewItem />
      </ProtectedRoute>

      <Route path={`${path}/:id`} render={({ match }) => {
        if (isNewsAdmin()) {
          return <Item />;
        }

        return <Redirect to={`/articles/${match.params.id}`} />
      }} />
    </Switch>
  );
};
